import React from 'react';
import { Field } from '../../Field/Field';
import { FieldContainer, Checkbox, CheckboxProps } from '../../Components';
import { FieldRenderProps } from '../../Field';

type Props = {
    label: string;
    description?: string;
    initialValue?: boolean;
};

export type CheckboxSingleFieldProps = Omit<
    FieldRenderProps<boolean>,
    'memoChild' | 'children' | 'initialValue' | 'onBlurValidate'
> &
    Omit<CheckboxProps, 'label' | 'isChecked' | 'onChange'> &
    Props;

export const CheckboxSingleField = ({
    id,
    name,
    label,
    description,
    initialValue = false,
    onChangeValidate,
    onSubmitValidate,
    required,
}: CheckboxSingleFieldProps) => {
    return (
        <Field<boolean>
            id={id}
            name={name}
            description={description}
            initialValue={initialValue}
            onChangeValidate={onChangeValidate}
            onSubmitValidate={onSubmitValidate}
            required={required}
        >
            {({
                fieldId,
                value,
                setValue,
                isValid,
                errors,
                errorId,
                descriptionId,
                required,
                requiredStrategy,
            }) => {
                return (
                    <FieldContainer
                        errorId={errorId}
                        errors={errors}
                        descriptionId={descriptionId}
                        description={description}
                    >
                        <Checkbox
                            id={fieldId}
                            label={label}
                            isChecked={value || false}
                            onChange={setValue}
                            aria-invalid={!isValid}
                            aria-errormessage={errorId}
                            aria-describedby={descriptionId}
                            required={required}
                            requiredStrategy={requiredStrategy}
                        />
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
